import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=06feb9f8&scoped=true&"
import script from "./indexCopy.vue?vue&type=script&lang=js&"
export * from "./indexCopy.vue?vue&type=script&lang=js&"
import style0 from "./indexCopy.vue?vue&type=style&index=0&id=06feb9f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06feb9f8",
  null
  
)

export default component.exports